/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Facility
 */
export interface Facility {
    /**
     * 
     * @type {number}
     * @memberof Facility
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'addressLine1'?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'zipCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'ediIdentity'?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'ediSendUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'ediReceiveUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'additionalProdTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Facility
     */
    'includeInRouting'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'holidays'?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Facility
     */
    'updatedDate'?: string;
}
/**
 * 
 * @export
 * @interface FacilityDto
 */
export interface FacilityDto {
    /**
     * 
     * @type {number}
     * @memberof FacilityDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'addressLine1'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'zipCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'ediIdentity'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'ediSendUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'ediReceiveUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'additionalProdTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FacilityDto
     */
    'includeInRouting'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'holidays'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityDto
     */
    'arrivalDate'?: string;
}
/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'number'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'memberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'status'?: OrderStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'subtotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'shipping'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'tax'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'refund'?: number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'discount'?: number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'coupon'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'purchaseDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'removed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'addressType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'addressLine1'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'xmls'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'pdfs'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'paymentIntent'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'statusHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'avataxTransactionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'receiptUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'maskedCard'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'edd'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'tracking'?: string;
    /**
     * 
     * @type {Facility}
     * @memberof Order
     */
    'facility'?: Facility;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'hasAddressError'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    'invoicePayment'?: boolean;
    /**
     * 
     * @type {Set<OrderItem>}
     * @memberof Order
     */
    'items'?: Set<OrderItem>;
}

export const OrderStatusEnum = {
    Draft: 'DRAFT',
    Paid: 'PAID',
    Sent: 'SENT',
    Processing: 'PROCESSING',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Canceled: 'CANCELED'
} as const;

export type OrderStatusEnum = typeof OrderStatusEnum[keyof typeof OrderStatusEnum];

/**
 * 
 * @export
 * @interface OrderDto
 */
export interface OrderDto {
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    'number'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'status'?: OrderDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    'subtotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    'shipping'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    'tax'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    'refund'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDto
     */
    'discount'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'coupon'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'notes'?: string;
    /**
     * 
     * @type {Array<OrderItemDto>}
     * @memberof OrderDto
     */
    'items'?: Array<OrderItemDto>;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'purchaseDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDto
     */
    'removed'?: boolean;
    /**
     * 
     * @type {FacilityDto}
     * @memberof OrderDto
     */
    'facility'?: FacilityDto;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'xmls'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'pdfs'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'paymentIntent'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'statusHistory'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'avataxTransactionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'receiptUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'maskedCard'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'edd'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'tracking'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'addressType'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'addressLine1'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDto
     */
    'phone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDto
     */
    'hasAddressError'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDto
     */
    'invoicePayment'?: boolean;
}

export const OrderDtoStatusEnum = {
    Draft: 'DRAFT',
    Paid: 'PAID',
    Sent: 'SENT',
    Processing: 'PROCESSING',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Canceled: 'CANCELED'
} as const;

export type OrderDtoStatusEnum = typeof OrderDtoStatusEnum[keyof typeof OrderDtoStatusEnum];

/**
 * 
 * @export
 * @interface OrderItem
 */
export interface OrderItem {
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'designId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'designName'?: string;
    /**
     * 
     * @type {Array<Product>}
     * @memberof OrderItem
     */
    'products'?: Array<Product>;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    'shippingFee'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    'pages'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'paperSize'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'paperType'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'designSize'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'pagination'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'lineItems'?: string;
    /**
     * 
     * @type {Order}
     * @memberof OrderItem
     */
    'order'?: Order;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItem
     */
    'gcStartingNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'thumbs'?: string;
}
/**
 * 
 * @export
 * @interface OrderItemDto
 */
export interface OrderItemDto {
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'designId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'designName'?: string;
    /**
     * 
     * @type {Array<Product>}
     * @memberof OrderItemDto
     */
    'products'?: Array<Product>;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDto
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDto
     */
    'shippingFee'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDto
     */
    'pages'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'paperSize'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'paperType'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'designSize'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'pagination'?: string;
    /**
     * 
     * @type {Order}
     * @memberof OrderItemDto
     */
    'order'?: Order;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'lineItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDto
     */
    'gcStartingNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'orderId'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemDto
     */
    'orderNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDto
     */
    'thumbs'?: string;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'paperSize'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'paperType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'sides'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'quantities'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'updatedDate'?: string;
}
/**
 * 
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'paperSize'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'paperType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'sides'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'quantities'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    'updatedDate'?: string;
}
/**
 * 
 * @export
 * @interface ProductSpecsDto
 */
export interface ProductSpecsDto {
    /**
     * 
     * @type {string}
     * @memberof ProductSpecsDto
     */
    'category'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductSpecsDto
     */
    'canBeSingleSided'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductSpecsDto
     */
    'canBeDoubleSided'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductSpecsDto
     */
    'paperTypes'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductSpecsDto
     */
    'sides'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductSpecsDto
     */
    'paginations'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductSpecsDto
     */
    'defaultPaper'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductSpecsDto
     */
    'defaultQuantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductSpecsDto
     */
    'defaultPagination'?: string;
}
/**
 * 
 * @export
 * @interface QuantityDto
 */
export interface QuantityDto {
    /**
     * 
     * @type {number}
     * @memberof QuantityDto
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuantityDto
     */
    'cost'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuantityDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuantityDto
     */
    'shippingFee'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuantityDto
     */
    'expShippingFee'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuantityDto
     */
    'productionTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuantityDto
     */
    'pricePerQuantity'?: number;
}
/**
 * 
 * @export
 * @interface QuoteDto
 */
export interface QuoteDto {
    /**
     * 
     * @type {ProductSpecsDto}
     * @memberof QuoteDto
     */
    'productSpecs'?: ProductSpecsDto;
    /**
     * 
     * @type {string}
     * @memberof QuoteDto
     */
    'pagination'?: string;
    /**
     * 
     * @type {number}
     * @memberof QuoteDto
     */
    'pages'?: number;
    /**
     * 
     * @type {Array<ProductDto>}
     * @memberof QuoteDto
     */
    'products'?: Array<ProductDto>;
    /**
     * 
     * @type {Array<QuantityDto>}
     * @memberof QuoteDto
     */
    'quantities'?: Array<QuantityDto>;
}
/**
 * 
 * @export
 * @interface RoutingRuleDto
 */
export interface RoutingRuleDto {
    /**
     * 
     * @type {number}
     * @memberof RoutingRuleDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof RoutingRuleDto
     */
    'minQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof RoutingRuleDto
     */
    'maxQuantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof RoutingRuleDto
     */
    'directive'?: string;
    /**
     * 
     * @type {Product}
     * @memberof RoutingRuleDto
     */
    'product'?: Product;
    /**
     * 
     * @type {Facility}
     * @memberof RoutingRuleDto
     */
    'facility'?: Facility;
    /**
     * 
     * @type {string}
     * @memberof RoutingRuleDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RoutingRuleDto
     */
    'updatedDate'?: string;
}

/**
 * FacilityResourceApi - axios parameter creator
 * @export
 */
export const FacilityResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FacilityDto} facilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create3: async (facilityDto: FacilityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityDto' is not null or undefined
            assertParamExists('create3', 'facilityDto', facilityDto)
            const localVarPath = `/v1/facilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete3: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delete3', 'id', id)
            const localVarPath = `/v1/facilities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get3: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/facilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll3: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/facilities/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FacilityDto} facilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update2: async (facilityDto: FacilityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityDto' is not null or undefined
            assertParamExists('update2', 'facilityDto', facilityDto)
            const localVarPath = `/v1/facilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacilityResourceApi - functional programming interface
 * @export
 */
export const FacilityResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacilityResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {FacilityDto} facilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create3(facilityDto: FacilityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create3(facilityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete3(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete3(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get3(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get3(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll3(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FacilityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll3(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FacilityDto} facilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update2(facilityDto: FacilityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update2(facilityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FacilityResourceApi - factory interface
 * @export
 */
export const FacilityResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacilityResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {FacilityDto} facilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create3(facilityDto: FacilityDto, options?: any): AxiosPromise<FacilityDto> {
            return localVarFp.create3(facilityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete3(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.delete3(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get3(id?: number, options?: any): AxiosPromise<FacilityDto> {
            return localVarFp.get3(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll3(options?: any): AxiosPromise<Array<FacilityDto>> {
            return localVarFp.getAll3(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacilityDto} facilityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update2(facilityDto: FacilityDto, options?: any): AxiosPromise<FacilityDto> {
            return localVarFp.update2(facilityDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FacilityResourceApi - object-oriented interface
 * @export
 * @class FacilityResourceApi
 * @extends {BaseAPI}
 */
export class FacilityResourceApi extends BaseAPI {
    /**
     * 
     * @param {FacilityDto} facilityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityResourceApi
     */
    public create3(facilityDto: FacilityDto, options?: AxiosRequestConfig) {
        return FacilityResourceApiFp(this.configuration).create3(facilityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityResourceApi
     */
    public delete3(id: number, options?: AxiosRequestConfig) {
        return FacilityResourceApiFp(this.configuration).delete3(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityResourceApi
     */
    public get3(id?: number, options?: AxiosRequestConfig) {
        return FacilityResourceApiFp(this.configuration).get3(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityResourceApi
     */
    public getAll3(options?: AxiosRequestConfig) {
        return FacilityResourceApiFp(this.configuration).getAll3(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacilityDto} facilityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacilityResourceApi
     */
    public update2(facilityDto: FacilityDto, options?: AxiosRequestConfig) {
        return FacilityResourceApiFp(this.configuration).update2(facilityDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * JobResourceApi - axios parameter creator
 * @export
 */
export const JobResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isActive: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/job/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggle: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/job/toggle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobResourceApi - functional programming interface
 * @export
 */
export const JobResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isActive(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isActive(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggle(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggle(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * JobResourceApi - factory interface
 * @export
 */
export const JobResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isActive(options?: any): AxiosPromise<boolean> {
            return localVarFp.isActive(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggle(options?: any): AxiosPromise<boolean> {
            return localVarFp.toggle(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobResourceApi - object-oriented interface
 * @export
 * @class JobResourceApi
 * @extends {BaseAPI}
 */
export class JobResourceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobResourceApi
     */
    public isActive(options?: AxiosRequestConfig) {
        return JobResourceApiFp(this.configuration).isActive(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobResourceApi
     */
    public toggle(options?: AxiosRequestConfig) {
        return JobResourceApiFp(this.configuration).toggle(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrderResourceApi - axios parameter creator
 * @export
 */
export const OrderResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment: async (id: string, admin: string, comment: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addComment', 'id', id)
            // verify required parameter 'admin' is not null or undefined
            assertParamExists('addComment', 'admin', admin)
            // verify required parameter 'comment' is not null or undefined
            assertParamExists('addComment', 'comment', comment)
            const localVarPath = `/v1/orders/{id}/comment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (admin !== undefined) {
                localVarQueryParameter['admin'] = admin;
            }

            if (comment !== undefined) {
                localVarQueryParameter['comment'] = comment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {OrderItemDto} orderItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItem: async (orderId: string, orderItemDto: OrderItemDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('addItem', 'orderId', orderId)
            // verify required parameter 'orderItemDto' is not null or undefined
            assertParamExists('addItem', 'orderItemDto', orderItemDto)
            const localVarPath = `/v1/orders/{orderId}/item`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {string} addressData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDeliveryAddress: async (id: string, admin: string, addressData: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeDeliveryAddress', 'id', id)
            // verify required parameter 'admin' is not null or undefined
            assertParamExists('changeDeliveryAddress', 'admin', admin)
            // verify required parameter 'addressData' is not null or undefined
            assertParamExists('changeDeliveryAddress', 'addressData', addressData)
            const localVarPath = `/v1/orders/{id}/delivery-address`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (admin !== undefined) {
                localVarQueryParameter['admin'] = admin;
            }

            if (addressData !== undefined) {
                localVarQueryParameter['addressData'] = addressData;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFacility: async (id: string, admin: string, facilityId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeFacility', 'id', id)
            // verify required parameter 'admin' is not null or undefined
            assertParamExists('changeFacility', 'admin', admin)
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('changeFacility', 'facilityId', facilityId)
            const localVarPath = `/v1/orders/{id}/facility`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (admin !== undefined) {
                localVarQueryParameter['admin'] = admin;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'} status 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStatus: async (id: string, admin: string, status: 'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED', comment: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeStatus', 'id', id)
            // verify required parameter 'admin' is not null or undefined
            assertParamExists('changeStatus', 'admin', admin)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('changeStatus', 'status', status)
            // verify required parameter 'comment' is not null or undefined
            assertParamExists('changeStatus', 'comment', comment)
            const localVarPath = `/v1/orders/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (admin !== undefined) {
                localVarQueryParameter['admin'] = admin;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (comment !== undefined) {
                localVarQueryParameter['comment'] = comment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OrderDto} orderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create2: async (orderDto: OrderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderDto' is not null or undefined
            assertParamExists('create2', 'orderDto', orderDto)
            const localVarPath = `/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete2: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delete2', 'id', id)
            const localVarPath = `/v1/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get2: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get2', 'id', id)
            const localVarPath = `/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll2: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/orders/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAdmin: async (from: string, to: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getAllAdmin', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getAllAdmin', 'to', to)
            const localVarPath = `/v1/public/orders/all/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByMemberIdIntercom: async (memberId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAllByMemberIdIntercom', 'memberId', memberId)
            const localVarPath = `/v1/public/orders/intercom`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'>} statuses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByStatuses: async (statuses: Array<'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statuses' is not null or undefined
            assertParamExists('getAllByStatuses', 'statuses', statuses)
            const localVarPath = `/v1/orders/all/statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItemsAdmin: async (from: string, to: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getAllItemsAdmin', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getAllItemsAdmin', 'to', to)
            const localVarPath = `/v1/public/orders/all/items/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/orders/all/late`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutMessage: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/orders/checkout/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraft: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getDraft', 'locationId', locationId)
            const localVarPath = `/v1/orders/draft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftItemsCount: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getDraftItemsCount', 'locationId', locationId)
            const localVarPath = `/v1/orders/draft/items/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedDeliveryDate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getExpectedDeliveryDate', 'id', id)
            const localVarPath = `/v1/orders/{id}/expected/delivery/date`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationOrders: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLocationOrders', 'locationId', locationId)
            const localVarPath = `/v1/orders/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberOrders: async (memberId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getMemberOrders', 'memberId', memberId)
            const localVarPath = `/v1/orders/member`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/orders/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderShippingNotification: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/orders/shipping/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPDFs: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('processPDFs', 'id', id)
            const localVarPath = `/v1/orders/{id}/process/pdfs`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPaidOrders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/orders/process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processXML: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('processXML', 'id', id)
            const localVarPath = `/v1/orders/{id}/process/xml`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} amount 
         * @param {string} type 
         * @param {string} admin 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refund: async (id: string, amount: number, type: string, admin: string, comment: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refund', 'id', id)
            // verify required parameter 'amount' is not null or undefined
            assertParamExists('refund', 'amount', amount)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('refund', 'type', type)
            // verify required parameter 'admin' is not null or undefined
            assertParamExists('refund', 'admin', admin)
            // verify required parameter 'comment' is not null or undefined
            assertParamExists('refund', 'comment', comment)
            const localVarPath = `/v1/orders/{id}/refund`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (admin !== undefined) {
                localVarQueryParameter['admin'] = admin;
            }

            if (comment !== undefined) {
                localVarQueryParameter['comment'] = comment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItem: async (orderId: string, itemId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('removeItem', 'orderId', orderId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('removeItem', 'itemId', itemId)
            const localVarPath = `/v1/orders/{orderId}/item/{itemId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OrderDto} orderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit: async (orderDto: OrderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderDto' is not null or undefined
            assertParamExists('submit', 'orderDto', orderDto)
            const localVarPath = `/v1/orders/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        test: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('test', 'id', id)
            const localVarPath = `/v1/public/orders/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} message 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCheckoutMessage: async (message: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'message' is not null or undefined
            assertParamExists('updateCheckoutMessage', 'message', message)
            const localVarPath = `/v1/orders/checkout/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (message !== undefined) {
                localVarQueryParameter['message'] = message;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {string} itemId 
         * @param {string} newQuantity 
         * @param {string} newPrice 
         * @param {string} newShipping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemQuantity: async (orderId: string, itemId: string, newQuantity: string, newPrice: string, newShipping: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('updateItemQuantity', 'orderId', orderId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('updateItemQuantity', 'itemId', itemId)
            // verify required parameter 'newQuantity' is not null or undefined
            assertParamExists('updateItemQuantity', 'newQuantity', newQuantity)
            // verify required parameter 'newPrice' is not null or undefined
            assertParamExists('updateItemQuantity', 'newPrice', newPrice)
            // verify required parameter 'newShipping' is not null or undefined
            assertParamExists('updateItemQuantity', 'newShipping', newShipping)
            const localVarPath = `/v1/orders/{orderId}/item/{itemId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (newQuantity !== undefined) {
                localVarQueryParameter['newQuantity'] = newQuantity;
            }

            if (newPrice !== undefined) {
                localVarQueryParameter['newPrice'] = newPrice;
            }

            if (newShipping !== undefined) {
                localVarQueryParameter['newShipping'] = newShipping;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OrderDto} orderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder: async (orderDto: OrderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderDto' is not null or undefined
            assertParamExists('updateOrder', 'orderDto', orderDto)
            const localVarPath = `/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} path 
         * @param {string} admin 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPdf: async (id: string, path: string, admin: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadPdf', 'id', id)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('uploadPdf', 'path', path)
            // verify required parameter 'admin' is not null or undefined
            assertParamExists('uploadPdf', 'admin', admin)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadPdf', 'file', file)
            const localVarPath = `/v1/orders/{id}/pdf/upload`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (admin !== undefined) {
                localVarQueryParameter['admin'] = admin;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderResourceApi - functional programming interface
 * @export
 */
export const OrderResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addComment(id: string, admin: string, comment: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addComment(id, admin, comment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {OrderItemDto} orderItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addItem(orderId: string, orderItemDto: OrderItemDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addItem(orderId, orderItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {string} addressData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeDeliveryAddress(id: string, admin: string, addressData: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeDeliveryAddress(id, admin, addressData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeFacility(id: string, admin: string, facilityId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeFacility(id, admin, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'} status 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeStatus(id: string, admin: string, status: 'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED', comment: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeStatus(id, admin, status, comment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OrderDto} orderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create2(orderDto: OrderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create2(orderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete2(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete2(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get2(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get2(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll2(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll2(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAdmin(from: string, to: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAdmin(from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllByMemberIdIntercom(memberId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllByMemberIdIntercom(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'>} statuses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllByStatuses(statuses: Array<'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllByStatuses(statuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllItemsAdmin(from: string, to: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllItemsAdmin(from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckoutMessage(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckoutMessage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraft(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraft(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftItemsCount(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftItemsCount(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExpectedDeliveryDate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExpectedDeliveryDate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationOrders(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationOrders(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberOrders(memberId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberOrders(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStats(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderShippingNotification(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderShippingNotification(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processPDFs(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processPDFs(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processPaidOrders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processPaidOrders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processXML(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processXML(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} amount 
         * @param {string} type 
         * @param {string} admin 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refund(id: string, amount: number, type: string, admin: string, comment: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refund(id, amount, type, admin, comment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeItem(orderId: string, itemId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeItem(orderId, itemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OrderDto} orderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submit(orderDto: OrderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submit(orderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async test(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.test(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} message 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCheckoutMessage(message: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCheckoutMessage(message, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {string} itemId 
         * @param {string} newQuantity 
         * @param {string} newPrice 
         * @param {string} newShipping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateItemQuantity(orderId: string, itemId: string, newQuantity: string, newPrice: string, newShipping: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateItemQuantity(orderId, itemId, newQuantity, newPrice, newShipping, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OrderDto} orderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrder(orderDto: OrderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrder(orderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} path 
         * @param {string} admin 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPdf(id: string, path: string, admin: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPdf(id, path, admin, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderResourceApi - factory interface
 * @export
 */
export const OrderResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addComment(id: string, admin: string, comment: string, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.addComment(id, admin, comment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {OrderItemDto} orderItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItem(orderId: string, orderItemDto: OrderItemDto, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.addItem(orderId, orderItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {string} addressData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeDeliveryAddress(id: string, admin: string, addressData: string, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.changeDeliveryAddress(id, admin, addressData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFacility(id: string, admin: string, facilityId: number, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.changeFacility(id, admin, facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} admin 
         * @param {'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'} status 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeStatus(id: string, admin: string, status: 'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED', comment: string, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.changeStatus(id, admin, status, comment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrderDto} orderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create2(orderDto: OrderDto, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.create2(orderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete2(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.delete2(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get2(id: string, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.get2(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll2(options?: any): AxiosPromise<Array<OrderDto>> {
            return localVarFp.getAll2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAdmin(from: string, to: string, options?: any): AxiosPromise<Array<OrderDto>> {
            return localVarFp.getAllAdmin(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByMemberIdIntercom(memberId: number, options?: any): AxiosPromise<Array<OrderDto>> {
            return localVarFp.getAllByMemberIdIntercom(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'>} statuses 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllByStatuses(statuses: Array<'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'>, options?: any): AxiosPromise<Array<OrderDto>> {
            return localVarFp.getAllByStatuses(statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItemsAdmin(from: string, to: string, options?: any): AxiosPromise<Array<OrderItemDto>> {
            return localVarFp.getAllItemsAdmin(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLate(options?: any): AxiosPromise<Array<OrderDto>> {
            return localVarFp.getAllLate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutMessage(options?: any): AxiosPromise<string> {
            return localVarFp.getCheckoutMessage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraft(locationId: number, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.getDraft(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftItemsCount(locationId: number, options?: any): AxiosPromise<number> {
            return localVarFp.getDraftItemsCount(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedDeliveryDate(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.getExpectedDeliveryDate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationOrders(locationId: number, options?: any): AxiosPromise<Array<OrderDto>> {
            return localVarFp.getLocationOrders(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberOrders(memberId: number, options?: any): AxiosPromise<Array<OrderDto>> {
            return localVarFp.getMemberOrders(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStats(options?: any): AxiosPromise<string> {
            return localVarFp.getStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderShippingNotification(options?: any): AxiosPromise<OrderDto> {
            return localVarFp.orderShippingNotification(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPDFs(id: string, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.processPDFs(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processPaidOrders(options?: any): AxiosPromise<string> {
            return localVarFp.processPaidOrders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processXML(id: string, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.processXML(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} amount 
         * @param {string} type 
         * @param {string} admin 
         * @param {string} comment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refund(id: string, amount: number, type: string, admin: string, comment: string, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.refund(id, amount, type, admin, comment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItem(orderId: string, itemId: string, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.removeItem(orderId, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrderDto} orderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit(orderDto: OrderDto, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.submit(orderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        test(id: string, options?: any): AxiosPromise<string> {
            return localVarFp.test(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} message 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCheckoutMessage(message: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateCheckoutMessage(message, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {string} itemId 
         * @param {string} newQuantity 
         * @param {string} newPrice 
         * @param {string} newShipping 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemQuantity(orderId: string, itemId: string, newQuantity: string, newPrice: string, newShipping: string, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.updateItemQuantity(orderId, itemId, newQuantity, newPrice, newShipping, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OrderDto} orderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder(orderDto: OrderDto, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.updateOrder(orderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} path 
         * @param {string} admin 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPdf(id: string, path: string, admin: string, file: any, options?: any): AxiosPromise<OrderDto> {
            return localVarFp.uploadPdf(id, path, admin, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderResourceApi - object-oriented interface
 * @export
 * @class OrderResourceApi
 * @extends {BaseAPI}
 */
export class OrderResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} admin 
     * @param {string} comment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public addComment(id: string, admin: string, comment: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).addComment(id, admin, comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {OrderItemDto} orderItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public addItem(orderId: string, orderItemDto: OrderItemDto, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).addItem(orderId, orderItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} admin 
     * @param {string} addressData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public changeDeliveryAddress(id: string, admin: string, addressData: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).changeDeliveryAddress(id, admin, addressData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} admin 
     * @param {number} facilityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public changeFacility(id: string, admin: string, facilityId: number, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).changeFacility(id, admin, facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} admin 
     * @param {'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'} status 
     * @param {string} comment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public changeStatus(id: string, admin: string, status: 'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED', comment: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).changeStatus(id, admin, status, comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrderDto} orderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public create2(orderDto: OrderDto, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).create2(orderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public delete2(id: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).delete2(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public get2(id: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).get2(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getAll2(options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getAll2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} from 
     * @param {string} to 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getAllAdmin(from: string, to: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getAllAdmin(from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getAllByMemberIdIntercom(memberId: number, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getAllByMemberIdIntercom(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'>} statuses 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getAllByStatuses(statuses: Array<'DRAFT' | 'PAID' | 'SENT' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELED'>, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getAllByStatuses(statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} from 
     * @param {string} to 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getAllItemsAdmin(from: string, to: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getAllItemsAdmin(from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getAllLate(options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getAllLate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getCheckoutMessage(options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getCheckoutMessage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getDraft(locationId: number, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getDraft(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getDraftItemsCount(locationId: number, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getDraftItemsCount(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getExpectedDeliveryDate(id: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getExpectedDeliveryDate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getLocationOrders(locationId: number, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getLocationOrders(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getMemberOrders(memberId: number, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getMemberOrders(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public getStats(options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).getStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public orderShippingNotification(options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).orderShippingNotification(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public processPDFs(id: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).processPDFs(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public processPaidOrders(options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).processPaidOrders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public processXML(id: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).processXML(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} amount 
     * @param {string} type 
     * @param {string} admin 
     * @param {string} comment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public refund(id: string, amount: number, type: string, admin: string, comment: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).refund(id, amount, type, admin, comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public removeItem(orderId: string, itemId: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).removeItem(orderId, itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrderDto} orderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public submit(orderDto: OrderDto, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).submit(orderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public test(id: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).test(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} message 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public updateCheckoutMessage(message: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).updateCheckoutMessage(message, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {string} itemId 
     * @param {string} newQuantity 
     * @param {string} newPrice 
     * @param {string} newShipping 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public updateItemQuantity(orderId: string, itemId: string, newQuantity: string, newPrice: string, newShipping: string, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).updateItemQuantity(orderId, itemId, newQuantity, newPrice, newShipping, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OrderDto} orderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public updateOrder(orderDto: OrderDto, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).updateOrder(orderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} path 
     * @param {string} admin 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderResourceApi
     */
    public uploadPdf(id: string, path: string, admin: string, file: any, options?: AxiosRequestConfig) {
        return OrderResourceApiFp(this.configuration).uploadPdf(id, path, admin, file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductResourceApi - axios parameter creator
 * @export
 */
export const ProductResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ProductDto} productDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1: async (productDto: ProductDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productDto' is not null or undefined
            assertParamExists('create1', 'productDto', productDto)
            const localVarPath = `/v1/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete1: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('delete1', 'id', id)
            const localVarPath = `/v1/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/products/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll1: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/products/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductsAdmin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/public/products/all/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProductDto} productDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1: async (productDto: ProductDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productDto' is not null or undefined
            assertParamExists('update1', 'productDto', productDto)
            const localVarPath = `/v1/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadFile', 'file', file)
            const localVarPath = `/v1/products/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductResourceApi - functional programming interface
 * @export
 */
export const ProductResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ProductDto} productDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create1(productDto: ProductDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create1(productDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete1(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadFile(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadFile(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get1(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll1(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllProductsAdmin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllProductsAdmin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProductDto} productDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update1(productDto: ProductDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update1(productDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: ProductDto; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductResourceApi - factory interface
 * @export
 */
export const ProductResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {ProductDto} productDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create1(productDto: ProductDto, options?: any): AxiosPromise<ProductDto> {
            return localVarFp.create1(productDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete1(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.delete1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadFile(options?: any): AxiosPromise<any> {
            return localVarFp.downloadFile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1(id?: number, options?: any): AxiosPromise<ProductDto> {
            return localVarFp.get1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll1(options?: any): AxiosPromise<Array<ProductDto>> {
            return localVarFp.getAll1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllProductsAdmin(options?: any): AxiosPromise<Array<ProductDto>> {
            return localVarFp.getAllProductsAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductDto} productDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1(productDto: ProductDto, options?: any): AxiosPromise<ProductDto> {
            return localVarFp.update1(productDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(file: any, options?: any): AxiosPromise<{ [key: string]: ProductDto; }> {
            return localVarFp.uploadFile(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductResourceApi - object-oriented interface
 * @export
 * @class ProductResourceApi
 * @extends {BaseAPI}
 */
export class ProductResourceApi extends BaseAPI {
    /**
     * 
     * @param {ProductDto} productDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductResourceApi
     */
    public create1(productDto: ProductDto, options?: AxiosRequestConfig) {
        return ProductResourceApiFp(this.configuration).create1(productDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductResourceApi
     */
    public delete1(id: number, options?: AxiosRequestConfig) {
        return ProductResourceApiFp(this.configuration).delete1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductResourceApi
     */
    public downloadFile(options?: AxiosRequestConfig) {
        return ProductResourceApiFp(this.configuration).downloadFile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductResourceApi
     */
    public get1(id?: number, options?: AxiosRequestConfig) {
        return ProductResourceApiFp(this.configuration).get1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductResourceApi
     */
    public getAll1(options?: AxiosRequestConfig) {
        return ProductResourceApiFp(this.configuration).getAll1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductResourceApi
     */
    public getAllProductsAdmin(options?: AxiosRequestConfig) {
        return ProductResourceApiFp(this.configuration).getAllProductsAdmin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductDto} productDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductResourceApi
     */
    public update1(productDto: ProductDto, options?: AxiosRequestConfig) {
        return ProductResourceApiFp(this.configuration).update1(productDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductResourceApi
     */
    public uploadFile(file: any, options?: AxiosRequestConfig) {
        return ProductResourceApiFp(this.configuration).uploadFile(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QuoteResourceApi - axios parameter creator
 * @export
 */
export const QuoteResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} category 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuote: async (category: string, body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('getQuote', 'category', category)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getQuote', 'body', body)
            const localVarPath = `/v1/public/featureQuote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} designSize 
         * @param {string} paperSize 
         * @param {string} paperType 
         * @param {number} pages 
         * @param {string} pagination 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuote1: async (designSize: string, paperSize: string, paperType: string, pages: number, pagination: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designSize' is not null or undefined
            assertParamExists('getQuote1', 'designSize', designSize)
            // verify required parameter 'paperSize' is not null or undefined
            assertParamExists('getQuote1', 'paperSize', paperSize)
            // verify required parameter 'paperType' is not null or undefined
            assertParamExists('getQuote1', 'paperType', paperType)
            // verify required parameter 'pages' is not null or undefined
            assertParamExists('getQuote1', 'pages', pages)
            // verify required parameter 'pagination' is not null or undefined
            assertParamExists('getQuote1', 'pagination', pagination)
            const localVarPath = `/v1/quote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (designSize !== undefined) {
                localVarQueryParameter['designSize'] = designSize;
            }

            if (paperSize !== undefined) {
                localVarQueryParameter['paperSize'] = paperSize;
            }

            if (paperType !== undefined) {
                localVarQueryParameter['paperType'] = paperType;
            }

            if (pages !== undefined) {
                localVarQueryParameter['pages'] = pages;
            }

            if (pagination !== undefined) {
                localVarQueryParameter['pagination'] = pagination;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} designSize 
         * @param {number} pages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecs: async (designSize: string, pages: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designSize' is not null or undefined
            assertParamExists('getSpecs', 'designSize', designSize)
            // verify required parameter 'pages' is not null or undefined
            assertParamExists('getSpecs', 'pages', pages)
            const localVarPath = `/v1/quote/specs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (designSize !== undefined) {
                localVarQueryParameter['designSize'] = designSize;
            }

            if (pages !== undefined) {
                localVarQueryParameter['pages'] = pages;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuoteResourceApi - functional programming interface
 * @export
 */
export const QuoteResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuoteResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} category 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuote(category: string, body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuote(category, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} designSize 
         * @param {string} paperSize 
         * @param {string} paperType 
         * @param {number} pages 
         * @param {string} pagination 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuote1(designSize: string, paperSize: string, paperType: string, pages: number, pagination: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuote1(designSize, paperSize, paperType, pages, pagination, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} designSize 
         * @param {number} pages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpecs(designSize: string, pages: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSpecsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpecs(designSize, pages, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QuoteResourceApi - factory interface
 * @export
 */
export const QuoteResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuoteResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} category 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuote(category: string, body: string, options?: any): AxiosPromise<string> {
            return localVarFp.getQuote(category, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} designSize 
         * @param {string} paperSize 
         * @param {string} paperType 
         * @param {number} pages 
         * @param {string} pagination 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuote1(designSize: string, paperSize: string, paperType: string, pages: number, pagination: string, options?: any): AxiosPromise<QuoteDto> {
            return localVarFp.getQuote1(designSize, paperSize, paperType, pages, pagination, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} designSize 
         * @param {number} pages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecs(designSize: string, pages: number, options?: any): AxiosPromise<ProductSpecsDto> {
            return localVarFp.getSpecs(designSize, pages, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuoteResourceApi - object-oriented interface
 * @export
 * @class QuoteResourceApi
 * @extends {BaseAPI}
 */
export class QuoteResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} category 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteResourceApi
     */
    public getQuote(category: string, body: string, options?: AxiosRequestConfig) {
        return QuoteResourceApiFp(this.configuration).getQuote(category, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} designSize 
     * @param {string} paperSize 
     * @param {string} paperType 
     * @param {number} pages 
     * @param {string} pagination 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteResourceApi
     */
    public getQuote1(designSize: string, paperSize: string, paperType: string, pages: number, pagination: string, options?: AxiosRequestConfig) {
        return QuoteResourceApiFp(this.configuration).getQuote1(designSize, paperSize, paperType, pages, pagination, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} designSize 
     * @param {number} pages 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuoteResourceApi
     */
    public getSpecs(designSize: string, pages: number, options?: AxiosRequestConfig) {
        return QuoteResourceApiFp(this.configuration).getSpecs(designSize, pages, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoutingRuleResourceApi - axios parameter creator
 * @export
 */
export const RoutingRuleResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/v1/routing-rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RoutingRuleDto} routingRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (routingRuleDto: RoutingRuleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'routingRuleDto' is not null or undefined
            assertParamExists('create', 'routingRuleDto', routingRuleDto)
            const localVarPath = `/v1/routing-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(routingRuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/routing-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/routing-rules/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RoutingRuleDto} routingRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (routingRuleDto: RoutingRuleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'routingRuleDto' is not null or undefined
            assertParamExists('update', 'routingRuleDto', routingRuleDto)
            const localVarPath = `/v1/routing-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(routingRuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoutingRuleResourceApi - functional programming interface
 * @export
 */
export const RoutingRuleResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoutingRuleResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RoutingRuleDto} routingRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(routingRuleDto: RoutingRuleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoutingRuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(routingRuleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoutingRuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoutingRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RoutingRuleDto} routingRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(routingRuleDto: RoutingRuleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoutingRuleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(routingRuleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoutingRuleResourceApi - factory interface
 * @export
 */
export const RoutingRuleResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoutingRuleResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RoutingRuleDto} routingRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(routingRuleDto: RoutingRuleDto, options?: any): AxiosPromise<RoutingRuleDto> {
            return localVarFp.create(routingRuleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id?: number, options?: any): AxiosPromise<RoutingRuleDto> {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: any): AxiosPromise<Array<RoutingRuleDto>> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RoutingRuleDto} routingRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(routingRuleDto: RoutingRuleDto, options?: any): AxiosPromise<RoutingRuleDto> {
            return localVarFp.update(routingRuleDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoutingRuleResourceApi - object-oriented interface
 * @export
 * @class RoutingRuleResourceApi
 * @extends {BaseAPI}
 */
export class RoutingRuleResourceApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutingRuleResourceApi
     */
    public _delete(id: number, options?: AxiosRequestConfig) {
        return RoutingRuleResourceApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RoutingRuleDto} routingRuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutingRuleResourceApi
     */
    public create(routingRuleDto: RoutingRuleDto, options?: AxiosRequestConfig) {
        return RoutingRuleResourceApiFp(this.configuration).create(routingRuleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutingRuleResourceApi
     */
    public get(id?: number, options?: AxiosRequestConfig) {
        return RoutingRuleResourceApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutingRuleResourceApi
     */
    public getAll(options?: AxiosRequestConfig) {
        return RoutingRuleResourceApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RoutingRuleDto} routingRuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutingRuleResourceApi
     */
    public update(routingRuleDto: RoutingRuleDto, options?: AxiosRequestConfig) {
        return RoutingRuleResourceApiFp(this.configuration).update(routingRuleDto, options).then((request) => request(this.axios, this.basePath));
    }
}


